export const SUPPORTED_LANGUAGES = [
  { code: 'en-US', name: 'English', flag: '🇺🇸' },
  { code: 'es-ES', name: 'Español', flag: '🇪🇸' },
  { code: 'fr-FR', name: 'Français', flag: '🇫🇷' },
  { code: 'de-DE', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
  { code: 'hi-IN', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ja-JP', name: '日本語', flag: '🇯🇵' },
];

export const TRANSLATIONS: Record<string, Record<string, string>> = {
  'en-US': {
    home: 'Home',
    movies: 'Movies',
    tvShows: 'TV Shows',
    searchPlaceholder: 'Search movies, TV shows, anime...',
    trendingMovies: 'Trending Movies',
    topRatedMovies: 'Top Rated Movies',
    trendingTv: 'Trending TV Shows',
    popularAnime: 'Popular Anime',
    actionMovies: 'Action Movies',
    comedyMovies: 'Comedy Movies',
    scifiFantasy: 'Sci-Fi & Fantasy',
    horrorMovies: 'Horror Movies',
    exploreMore: 'Explore More',
    loadMore: 'Load More',
    continueWatching: 'Continue Watching',
    playbackSettings: 'Playback Settings',
    videoServer: 'Video Server',
    directDownloads: 'Direct MP4 Downloads',
    reviewsComments: 'Reviews & Comments',
    moreLikeThis: 'More Titles Like This',
    infiniteScroll: 'Infinite Scroll',
    manualLoading: 'Manual Load',
    serverStatus: 'Server Status & Speed',
    speedTest: 'Test Speeds',
    active: 'Active',
    slow: 'Slow',
    offline: 'Offline / Blocked',
    reportBroken: 'Report Server Error',
    subTitle: 'Sub (Original)',
    dubTitle: 'Dub (English)',
    playerStuck: 'Player stuck?',
    playerStuckDesc: 'Try switching servers or refreshing the player using the controls below.',
    forceRefresh: 'Force Player Refresh',
    fullDetails: 'Full Title Details',
    reportSuccess: 'Server reported successfully! Thank you for keeping CineStream clean.',
    testing: 'Testing...',
  },
  'es-ES': {
    home: 'Inicio',
    movies: 'Películas',
    tvShows: 'Series de TV',
    searchPlaceholder: 'Buscar películas, series, anime...',
    trendingMovies: 'Películas en Tendencia',
    topRatedMovies: 'Películas Mejor Valoradas',
    trendingTv: 'Series en Tendencia',
    popularAnime: 'Anime Popular',
    actionMovies: 'Películas de Acción',
    comedyMovies: 'Películas de Comedia',
    scifiFantasy: 'Ciencia Ficción y Fantasía',
    horrorMovies: 'Películas de Terror',
    exploreMore: 'Explorar Más',
    loadMore: 'Cargar Más',
    continueWatching: 'Seguir Viendo',
    playbackSettings: 'Ajustes de Reproducción',
    videoServer: 'Servidor de Video',
    directDownloads: 'Descargas Directas MP4',
    reviewsComments: 'Reseñas y Comentarios',
    moreLikeThis: 'Más Títulos Como Este',
    infiniteScroll: 'Desplazamiento Infinito',
    manualLoading: 'Carga Manual',
    serverStatus: 'Estado y Velocidad del Servidor',
    speedTest: 'Probar Velocidades',
    active: 'Activo',
    slow: 'Lento',
    offline: 'Sin conexión / Bloqueado',
    reportBroken: 'Reportar Fallo del Servidor',
    subTitle: 'Sub (Original)',
    dubTitle: 'Doblaje (Inglés)',
    playerStuck: '¿Reproductor bloqueado?',
    playerStuckDesc: 'Intenta cambiar de servidor o actualizar el reproductor usando los controles de abajo.',
    forceRefresh: 'Forzar Actualización de Reproductor',
    fullDetails: 'Detalles Completos del Título',
    reportSuccess: '¡Servidor reportado con éxito! Gracias por mantener CineStream limpio.',
    testing: 'Probando...',
  },
  'fr-FR': {
    home: 'Accueil',
    movies: 'Films',
    tvShows: 'Séries TV',
    searchPlaceholder: 'Rechercher des films, séries, animes...',
    trendingMovies: 'Films du Moment',
    topRatedMovies: 'Films les Mieux Notés',
    trendingTv: 'Séries du Moment',
    popularAnime: 'Animes Populaires',
    actionMovies: 'Films d\'Action',
    comedyMovies: 'Comédies',
    scifiFantasy: 'Science-Fiction & Fantastique',
    horrorMovies: 'Films d\'Horreur',
    exploreMore: 'Explorer Plus',
    loadMore: 'Charger Plus',
    continueWatching: 'Reprendre la Lecture',
    playbackSettings: 'Paramètres de Lecture',
    videoServer: 'Serveur Vidéo',
    directDownloads: 'Téléchargements Directs MP4',
    reviewsComments: 'Avis & Commentaires',
    moreLikeThis: 'Plus de Titres Similaires',
    infiniteScroll: 'Défilement Infini',
    manualLoading: 'Chargement Manuel',
    serverStatus: 'État et Vitesse du Serveur',
    speedTest: 'Tester la Vitesse',
    active: 'Actif',
    slow: 'Lent',
    offline: 'Hors ligne / Bloqué',
    reportBroken: 'Signaler un Problème',
    subTitle: 'VO (Sous-titré)',
    dubTitle: 'VF (Doublé)',
    playerStuck: 'Lecteur bloqué ?',
    playerStuckDesc: 'Essayez de changer de serveur ou de forcer le rafraîchissement du lecteur ci-dessous.',
    forceRefresh: 'Forcer l\'Actualisation',
    fullDetails: 'Détails du Titre',
    reportSuccess: 'Signalement envoyé ! Merci de nous aider à garder CineStream opérationnel.',
    testing: 'Test en cours...',
  },
  'de-DE': {
    home: 'Startseite',
    movies: 'Filme',
    tvShows: 'Serien',
    searchPlaceholder: 'Filme, Serien, Anime suchen...',
    trendingMovies: 'Angesagte Filme',
    topRatedMovies: 'Am besten bewertete Filme',
    trendingTv: 'Angesagte Serien',
    popularAnime: 'Beliebte Animes',
    actionMovies: 'Actionfilme',
    comedyMovies: 'Komödien',
    scifiFantasy: 'Sci-Fi & Fantasy',
    horrorMovies: 'Horrorfilme',
    exploreMore: 'Mehr Entdecken',
    loadMore: 'Mehr Laden',
    continueWatching: 'Weiterschauen',
    playbackSettings: 'Wiedergabeeinstellungen',
    videoServer: 'Videoserver',
    directDownloads: 'Direkte MP4-Downloads',
    reviewsComments: 'Bewertungen & Kommentare',
    moreLikeThis: 'Ähnliche Titel',
    infiniteScroll: 'Endloses Scrollen',
    manualLoading: 'Manuelles Laden',
    serverStatus: 'Serverstatus & Geschwindigkeit',
    speedTest: 'Geschwindigkeit testen',
    active: 'Aktiv',
    slow: 'Langsam',
    offline: 'Offline / Blockiert',
    reportBroken: 'Serverfehler melden',
    subTitle: 'Sub (Original)',
    dubTitle: 'Dub (Englisch)',
    playerStuck: 'Player hängt?',
    playerStuckDesc: 'Wechsle den Server oder lade den Player mit den Steuerelementen unten neu.',
    forceRefresh: 'Aktualisierung erzwingen',
    fullDetails: 'Komplette Titeldetails',
    reportSuccess: 'Serverfehler gemeldet! Vielen Dank, dass du CineStream sauber hältst.',
    testing: 'Testen...',
  },
  'pt-BR': {
    home: 'Início',
    movies: 'Filmes',
    tvShows: 'Séries',
    searchPlaceholder: 'Buscar filmes, séries, animes...',
    trendingMovies: 'Filmes Populares',
    topRatedMovies: 'Mais Bem Avaliados',
    trendingTv: 'Séries Populares',
    popularAnime: 'Animes Populares',
    actionMovies: 'Filmes de Ação',
    comedyMovies: 'Filmes de Comédia',
    scifiFantasy: 'Ficção Científica e Fantasia',
    horrorMovies: 'Filmes de Terror',
    exploreMore: 'Explorar Mais',
    loadMore: 'Carregar Mais',
    continueWatching: 'Continuar Assistindo',
    playbackSettings: 'Ajustes de Reprodução',
    videoServer: 'Servidor de Vídeo',
    directDownloads: 'Downloads Diretos MP4',
    reviewsComments: 'Avaliações e Comentários',
    moreLikeThis: 'Mais Títulos Como Este',
    infiniteScroll: 'Rolagem Infinita',
    manualLoading: 'Carregamento Manual',
    serverStatus: 'Status e Velocidade do Servidor',
    speedTest: 'Testar Velocidades',
    active: 'Ativo',
    slow: 'Lento',
    offline: 'Offline / Bloqueado',
    reportBroken: 'Reportar Erro no Servidor',
    subTitle: 'Legendado (Original)',
    dubTitle: 'Dublado (Português)',
    playerStuck: 'Player travou?',
    playerStuckDesc: 'Tente mudar de servidor ou atualizar o player usando os controles abaixo.',
    forceRefresh: 'Forçar Atualização do Player',
    fullDetails: 'Detalhes Completos',
    reportSuccess: 'Erro reportado com sucesso! Obrigado por manter o CineStream limpo.',
    testing: 'Testando...',
  },
  'hi-IN': {
    home: 'होम',
    movies: 'फ़िल्में',
    tvShows: 'टीवी शो',
    searchPlaceholder: 'फ़िल्में, टीवी शो, एनिमे खोजें...',
    trendingMovies: 'ट्रेंडिंग फ़िल्में',
    topRatedMovies: 'टॉप रेटेड फ़िल्में',
    trendingTv: 'ट्रेंडिंग टीवी शो',
    popularAnime: 'लोकप्रिय एनिमे',
    actionMovies: 'एक्शन फ़िल्में',
    comedyMovies: 'कॉमेडी फ़िल्में',
    scifiFantasy: 'विज्ञान कथा और फंतासी',
    horrorMovies: 'हॉरर फ़िल्में',
    exploreMore: 'और देखें',
    loadMore: 'और लोड करें',
    continueWatching: 'देखना जारी रखें',
    playbackSettings: 'प्लेबैक सेटिंग्स',
    videoServer: 'वीडियो सर्वर',
    directDownloads: 'डायरेक्ट MP4 डाउनलोड',
    reviewsComments: 'समीक्षाएं और टिप्पणियां',
    moreLikeThis: 'इस तरह के और शो',
    infiniteScroll: 'अंतहीन स्क्रॉल',
    manualLoading: 'मैन्युअल लोड',
    serverStatus: 'सर्वर स्थिति और गति',
    speedTest: 'गति का परीक्षण करें',
    active: 'सक्रिय',
    slow: 'धीमा',
    offline: 'ऑफ़लाइन / अवरुद्ध',
    reportBroken: 'सर्वर त्रुटि रिपोर्ट करें',
    subTitle: 'सब (मूल)',
    dubTitle: 'डब (अंग्रेजी)',
    playerStuck: 'प्लेयर अटक गया है?',
    playerStuckDesc: 'सर्वर बदलने या नीचे दिए गए नियंत्रणों का उपयोग करके प्लेयर को रीफ़्रेश करने का प्रयास करें।',
    forceRefresh: 'प्लेयर को रीफ़्रेश करें',
    fullDetails: 'पूर्ण विवरण',
    reportSuccess: 'सर्वर त्रुटि की सूचना सफलतापूर्वक दी गई! CineStream को स्वच्छ रखने के लिए धन्यवाद।',
    testing: 'परीक्षण जारी...',
  },
  'ja-JP': {
    home: 'ホーム',
    movies: '映画',
    tvShows: 'テレビ番組',
    searchPlaceholder: '映画、ドラマ、アニメを検索...',
    trendingMovies: '急上昇中の映画',
    topRatedMovies: '高評価の映画',
    trendingTv: '急上昇中のテレビ番組',
    popularAnime: '人気の高いアニメ',
    actionMovies: 'アクション映画',
    comedyMovies: 'コメディ映画',
    scifiFantasy: 'SF＆ファンタジー',
    horrorMovies: 'ホラー映画',
    exploreMore: 'もっと見る',
    loadMore: 'さらに読み込む',
    continueWatching: '視聴を続ける',
    playbackSettings: '再生設定',
    videoServer: 'ビデオサーバー',
    directDownloads: '直接MP4ダウンロード',
    reviewsComments: 'レビューとコメント',
    moreLikeThis: '似ている作品',
    infiniteScroll: '無限スクロール',
    manualLoading: '手動読み込み',
    serverStatus: 'サーバーの状態と速度',
    speedTest: '速度測定',
    active: '稼働中',
    slow: '遅い',
    offline: 'オフライン / ブロック中',
    reportBroken: 'リンク切れを報告',
    subTitle: '字幕（オリジナル）',
    dubTitle: '吹替（英語）',
    playerStuck: '再生が止まりましたか？',
    playerStuckDesc: '他のサーバーに切り替えるか、以下のボタンでリフレッシュしてください。',
    forceRefresh: '強制リフレッシュ',
    fullDetails: '作品の詳細情報',
    reportSuccess: '報告ありがとうございます！CineStreamの健全性維持にご協力いただき感謝します。',
    testing: '測定中...',
  }
};

export const getTMDBLanguage = (): string => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('tmdb_language') || 'en-US';
  }
  return 'en-US';
};

export const setTMDBLanguage = (code: string) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('tmdb_language', code);
    // Dispatch custom event to let components listen to language change
    window.dispatchEvent(new Event('languageChanged'));
  }
};

export const getTranslation = (key: string): string => {
  const lang = getTMDBLanguage();
  const dict = TRANSLATIONS[lang] || TRANSLATIONS['en-US'];
  return dict[key] || TRANSLATIONS['en-US'][key] || key;
};
